import { defineAnnotationToolStore } from '@/src/utils/defineAnnotationToolStore';
import type { Vector3 } from '@kitware/vtk.js/types';
import { ToolID } from '@/src/types/annotation-tool';

import { FREEHAND_LABEL_DEFAULTS } from '@/src/config';
import { Manifest, StateFile } from '@/src/io/state-file/schema';

import { useAnnotationTool } from './useAnnotationTool';

const freehandDefaults = () => ({
  points: [] as Array<Vector3>,
  id: '' as ToolID,
  name: 'Freehand',
});

export const useFreehandStore = defineAnnotationToolStore('freehand', () => {
  const toolAPI = useAnnotationTool({
    toolDefaults: freehandDefaults,
    initialLabels: FREEHAND_LABEL_DEFAULTS,
  });

  function getPoints(id: ToolID) {
    const tool = toolAPI.toolByID.value[id];
    return tool.points;
  }

  // --- serialization --- //

  function serialize(state: StateFile) {
    if (!state.manifest.tools) return;
    state.manifest.tools.freehands = toolAPI.serializeTools();
  }

  function deserialize(manifest: Manifest, dataIDMap: Record<string, string>) {
    toolAPI.deserializeTools(manifest.tools?.freehands, dataIDMap);
  }

  return {
    ...toolAPI,
    getPoints,
    serialize,
    deserialize,
  };
});
